module.exports = __webpack_public_path__ + "img/hat-icon_3.d7b97beb.png";